import { PairedCostAdjustmentSummaryTableRow } from './PairedCostAdjustmentSummaryTableRow.js';
import { PairedCostAdjustmentSummaryProps } from './types.js';

export const PairedCostAdjustmentSummaryTableMainDwellingRows = (
  props: PairedCostAdjustmentSummaryProps,
) => {
  const areaAdjustmentLabels =
    props.propertyTypeSet.size === 1 && props.propertyTypeSet.has('multiFamily')
      ? {
          'mainDwelling.gla': 'GBA',
        }
      : props.adjustmentLabels;
  return (
    <>
      <PairedCostAdjustmentSummaryTableRow
        {...props}
        adjustmentLabels={areaAdjustmentLabels}
        row={{ path: 'mainDwelling.gla', alwaysShow: true }}
      />
      {(props.propertyTypeSet.has('multiFamily') ||
        props.propertyTypeSet.has('duplex') ||
        props.propertyTypeSet.has('triplex') ||
        props.propertyTypeSet.has('quadruplex')) && (
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{
            path: 'mainDwelling.units',
            alwaysShow: true,
            suppressDetails: false,
          }}
          includeAdjustmentCell={true}
        />
      )}
      {props.propertyTypeSet.size > 1 && (
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{
            path: 'mainDwelling.propertyType',
            alwaysShow: true,
            suppressDetails: true,
          }}
          includeAdjustmentCell={false}
        />
      )}
    </>
  );
};
